









import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BackButton",

  props: {
    text: {
      type: String,
      default: "back"
    },
    path: String
  },

  setup() {
    return {};
  }
});
